<template>
  <div class="row">
    <div v-if="title" class="col-sm-12 my-4 d-flex justify-content-center">
      <h3>
        <span>{{ title }}</span>
        <button v-if="!edit" class="btn btn-link btn-sm btn-fill btn-wd float-right" @click="$emit('edit')">
          <i class="fas fa-plus mr-1"></i>Agregar Articulos
        </button>
      </h3>
    </div>

    <!-- SM MD LG XL -->
    <div class="col-sm-12 mb-4 d-none d-sm-block">
      <div class="row">
        <div class="col-sm-2"><h4>Código</h4></div>
        <div class="col-sm-2 text-center"><h4>Artículo</h4></div>
        <div class="col-sm-4 text-center"><h4>Cantidad</h4></div>
      </div>
    </div>

    <!-- SM MD LG XL -->
    <div v-for="(item, index) in items" :key="'normal' + index" class="col-sm-12 d-none d-sm-block">
      <div class="row">
        <div class="col-sm-2">
          <small>{{ item.article.code }}</small>
        </div>
        <div class="col-sm-2 text-center">
          <small>{{ item.article.description }}</small>
        </div>
        <div class="col-sm-4 text-center">
          <small>{{ item.quantity }}</small>
        </div>
        <div v-if="edit" class="col-sm-2">
          <base-button
            class="rounded-pill btn btn-danger btn-sm"
            size="sm"
            type="danger"
            title="Eliminar"
            @click="deleteItem(item.id, index)"
          >
            <i class="fas fa-trash mr-1"></i>Eliminar
          </base-button>
        </div>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemInfo',
  props: {
    items: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      title: 'Lista de Articulos del Remito',
      edit: true,
    };
  },

  methods: {
    deleteItem(id, index) {
      this.$emit('deleteItem', id, index);
    },
  },
};
</script>
